export const REVENUE_DATE = 'REVENUE_DATE';
export const SITE_PAYMENT_DATE = 'SITE_PAYMENT_DATE';
